var poll_header_default = {
  "title": "ATEFo",
  "image": "m0Cf2",
  "webview": "TjTMM"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
